module.exports = __webpack_public_path__ + "img/magnifying-glass-black.2d2fc825.svg";